module.exports = __webpack_public_path__ + "static/media/moveTable-white.16e0b581.png";